module.exports = __webpack_public_path__ + "img/details.50e13991.png";